module.exports = __webpack_public_path__ + "fb67863e9fb8183bc591511684dbe9ac.svg";